import SidebarUnitDesktop from "../../components/SidebarUnitDesktop";
import {MissionIcon} from "../../../../assets/icons";

const MissionPeriodDL = () => {
    return (
        <SidebarUnitDesktop 
            routeName={"Missions"} 
            routeSidebar={"/missions"}
            icon={MissionIcon}
            text="Missions"
        />
    )
}

export default MissionPeriodDL;